import React from 'react';

interface StatusUpIconProps {
  size?: number;
  color?: string;
}

/**
 * StatusUpIcon Component
 * @description A circular icon with upward chevron indicating "up" or "active" status
 */
export const StatusUpIcon: React.FC<StatusUpIconProps> = ({ 
  size = 32, 
  color = '#14AE5C' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 32 32"
    >
      <mask 
        id="statusUpMask" 
        width="30" 
        height="30" 
        x="1" 
        y="1" 
        maskUnits="userSpaceOnUse" 
        style={{ maskType: 'luminance' }}
      >
        <path 
          stroke="#fff" 
          strokeWidth="2.667" 
          d="M16 29.333c7.364 0 13.334-5.969 13.334-13.333S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333Z"
        />
        <path 
          fill="#fff" 
          stroke="#fff" 
          strokeLinejoin="round" 
          strokeWidth="2.667" 
          d="M16 29.333c7.364 0 13.334-5.969 13.334-13.333S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333Z"
        />
        <path 
          stroke="#000" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2.667" 
          d="m22 18-6-6-6 6"
        />
      </mask>
      <g mask="url(#statusUpMask)">
        <path fill={color} d="M0 0h32v32H0z" />
      </g>
    </svg>
  );
};

export default StatusUpIcon;

